import styled from 'styled-components';
import { CredusText, color } from 'ui';

import { Loader } from '../../assets/images/svgs';

interface PageLoaderProps {
  loaderText: string;
}

const PageLoader = ({ loaderText }: PageLoaderProps) => {
  return (
    <Container>
      <div>
        <Loader />
        <CredusText weight="medium" size="xl">
          {loaderText}
        </CredusText>
      </div>
    </Container>
  );
};

export default PageLoader;

const Container = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background: ${color.white};
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;
